module.exports = __webpack_public_path__ + "static/media/W4@1.5x.e597982c.png";